import backofficeService from "../../api/backoffice"

function createIdempotencyKey() {
  const cryptoApi = window.crypto || window.msCrypto
  if (cryptoApi && cryptoApi.randomUUID) return cryptoApi.randomUUID()

  const bytes = new Uint8Array(16)
  if (cryptoApi && cryptoApi.getRandomValues) cryptoApi.getRandomValues(bytes)
  else for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0"))
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`
}

export default {
  Usage: {
    recordOpen({ reportKey, reportName, route, filters, LocationId }) {
      return backofficeService.Api().post("reportUsage/open", {
        reportKey,
        reportName,
        route,
        openedAt: new Date().toISOString(),
        filters,
        LocationId,
        idempotencyKey: createIdempotencyKey(),
      })
        .then(response => response.data)
        .catch(() => null)
    },
  },
  Sales: {
    /**
     * Returns base sales like revenue, tax, net sales, discounts
     * @param {*} params
     */
    get(params = {}) {
      return backofficeService
        .Api()
        .get("reports/sales", { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    getByLocation(params = {}) {
      return backofficeService
        .Api()
        .get("reports/sales/byLocation", { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
  },
  Location: {
    daySummary(params = {}) {
      return backofficeService
        .Api()
        .get("reports/location/daySummary", { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    payments(params = {}) {
      return backofficeService
        .Api()
        .get("reports/location/payments", { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    taxes(params = {}) {
      return backofficeService
        .Api()
        .get("reports/location/taxes", { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
  },
  TimeClock: {
    /**
     * Returns timeClock of given employee
     * @param {*} params
     */
    get(id, params = {}) {
      return backofficeService
        .Api()
        .get(`reports/employee/${id}/timeClock`, { params })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
  },
  sendReportPDF(data) {
    return backofficeService
      .Api()
      .post("/tools/email/report", data)
      .then(response => response.status === 200)
      .catch(error => {
        throw error
      })
  },
  /**
   * Get all expense cateogry
   * @param {*} params Query Options
   */
  getExpenseList(params) {
    return backofficeService
      .Api()
      .get("reports/expenses/getHistory", { params })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  getProfitAndLoss(params = {}) {
    return backofficeService
      .Api()
      .get("reports/location/profitAndLoss", { params })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  },
}
